import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    bvn: "",
    phoneNumber: "",
    workId: null,
    sixMonthsBankStatement: null,
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { register } = useAuth();

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    try {
      await register(data); // Ensure your backend handles multipart/form-data
      navigate("/login");
    } catch (err) {
      setError(err.message || "Registration failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 mt-3 pb-2">
            Create your account
          </h2>
        </div>
        {error && (
          <div className="bg-red-100 text-red-700 p-4 rounded mb-4">
            {error}
          </div>
        )}
        <div className="d-flex justify-content-center align-items-center">
        <form
          style={{ maxWidth: "700px" }}
          className="mt-8 space-y-6 w-100"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <div className="space-y-4">
            <input
              name="email"
              type="email"
              required
              placeholder="Email"
              onChange={handleChange}
              className="form-control input py-2 w-100 mb-2"
            /> 
            <input
              name="password"
              type="password"
              required
              placeholder="Password"
              onChange={handleChange}
              className="form-control input py-2 w-100 mb-2"
            /> 
            <input
              name="firstName"
              type="text"
              required
              placeholder="First Name"
              onChange={handleChange}
              className="form-control input py-2 w-100 mb-2"
            /> 
            <input
              name="lastName"
              type="text"
              required
              placeholder="Last Name"
              onChange={handleChange}
              className="form-control input py-2 w-100 mb-2"
            /> 
            <input
              name="bvn"
              type="text"
              required
              placeholder="BVN"
              onChange={handleChange}
              className="form-control input py-2 w-100 mb-2"
            /> 
            <input
              name="phoneNumber"
              type="tel"
              required
              placeholder="Phone Number"
              onChange={handleChange}
              className="form-control input py-2 w-100 mb-2"
            /> 

            {/* Work ID (image upload) */}
            <label className="block text-sm font-medium text-gray-700">
              Upload Work ID (image)
            </label>
            <input
              name="workId"
              type="file"
              accept="image/*"
              required
              onChange={handleChange}
              className="form-control input mb-2"
            /> 

            {/* Bank Statement (file upload) */}
            <label className="block text-sm font-medium text-gray-700">
              Upload 6 Months Bank Statement (PDF or Image)
            </label>
            <input
              name="sixMonthsBankStatement"
              type="file"
              accept=".pdf,image/*"
              required
              onChange={handleChange}
              className="form-control input"
            />
          </div>

          <button type="submit" className="btn btn-primary w-100  py-2 mt-4 fs-4">
            Register
          </button>
        </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
